(function () {
  if (window.__GA_FILTER_STABILITY__) return;
  window.__GA_FILTER_STABILITY__ = true;

  /* Neutralise the previous standalone motion controller if it is ever loaded elsewhere. */
  window.__GA_FILTER_DRAWER_MOTION__ = true;

  var CLOSE_MS = 360;
  var closeTimer = null;
  var observer = null;

  function getElements() {
    return {
      drawer: document.getElementById('gaFiltersDrawer'),
      backdrop: document.getElementById('gaFiltersBackdrop'),
      openButton: document.getElementById('gaFiltersOpen')
    };
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function prepare() {
    var els = getElements();
    if (!els.drawer || !els.backdrop) return null;

    els.drawer.classList.add('ga-filter-motion-ready');
    els.backdrop.classList.add('ga-filter-motion-ready');

    if (els.openButton) {
      els.openButton.setAttribute('aria-controls', 'gaFiltersDrawer');
    }

    return els;
  }

  function initPriceSliders() {
    document.querySelectorAll('[data-ga-price-filter]').forEach(function (wrapper) {
      if (wrapper.dataset.loaded === 'true') return;
      wrapper.dataset.loaded = 'true';

      var min = Number(wrapper.dataset.min || 0);
      var max = Number(wrapper.dataset.max || 0);
      var minInput = wrapper.querySelector('[data-ga-price-min-input]');
      var maxInput = wrapper.querySelector('[data-ga-price-max-input]');
      var minRange = wrapper.querySelector('[data-ga-price-min-range]');
      var maxRange = wrapper.querySelector('[data-ga-price-max-range]');
      var fill = wrapper.querySelector('[data-ga-price-fill]');
      var leftLabel = wrapper.querySelector('[data-ga-price-left]');
      var rightLabel = wrapper.querySelector('[data-ga-price-right]');

      if (!minInput || !maxInput || !minRange || !maxRange || !max) return;

      function update(source) {
        var minVal = Number(minInput.value || min);
        var maxVal = Number(maxInput.value || max);

        if (minVal < min) minVal = min;
        if (maxVal > max) maxVal = max;

        if (minVal > maxVal - 1) {
          if (source === 'min') minVal = maxVal - 1;
          if (source === 'max') maxVal = minVal + 1;
        }

        minInput.value = minVal;
        maxInput.value = maxVal;
        minRange.value = minVal;
        maxRange.value = maxVal;

        if (fill) {
          fill.style.left = ((minVal / max) * 100) + '%';
          fill.style.right = (100 - ((maxVal / max) * 100)) + '%';
        }

        if (leftLabel) leftLabel.textContent = '€' + minVal;
        if (rightLabel) rightLabel.textContent = '€' + maxVal;
      }

      minRange.addEventListener('input', function () {
        minInput.value = minRange.value;
        update('min');
      });

      maxRange.addEventListener('input', function () {
        maxInput.value = maxRange.value;
        update('max');
      });

      minInput.addEventListener('input', function () { update('min'); });
      maxInput.addEventListener('input', function () { update('max'); });
      update();
    });
  }

  function prioritiseVisibleProductImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('#product-grid .ga-media-img:not(.ga-media-img--secondary)');

    Array.prototype.slice.call(images, 0, 8).forEach(function (img, index) {
      if (index < 4) {
        img.loading = 'eager';
        img.setAttribute('loading', 'eager');
        img.fetchPriority = 'high';
        img.setAttribute('fetchpriority', 'high');
      }
      img.style.removeProperty('visibility');
    });
  }

  function openDrawer() {
    var els = prepare();
    if (!els) return;

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    els.drawer.hidden = false;
    els.backdrop.hidden = false;
    els.drawer.setAttribute('aria-hidden', 'false');
    els.drawer.classList.add('is-active');
    els.backdrop.classList.add('is-active');
    document.documentElement.classList.add('ga-filters-open');

    if (els.openButton) els.openButton.setAttribute('aria-expanded', 'true');

    initPriceSliders();

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        els.drawer.classList.add('is-motion-open');
        els.backdrop.classList.add('is-motion-open');
      });
    });
  }

  function finishClose() {
    var els = getElements();
    if (!els.drawer || !els.backdrop) return;

    els.drawer.hidden = true;
    els.backdrop.hidden = true;
    els.drawer.classList.remove('is-motion-open', 'is-active');
    els.backdrop.classList.remove('is-motion-open', 'is-active');
    els.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ga-filters-open');
    if (els.openButton) els.openButton.setAttribute('aria-expanded', 'false');
    closeTimer = null;
  }

  function closeDrawer() {
    var els = prepare();
    if (!els) return;

    els.drawer.classList.remove('is-motion-open', 'is-active');
    els.backdrop.classList.remove('is-motion-open', 'is-active');
    els.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ga-filters-open');
    if (els.openButton) els.openButton.setAttribute('aria-expanded', 'false');

    if (reducedMotion()) {
      finishClose();
      return;
    }

    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(finishClose, CLOSE_MS);
  }

  /* The FILTER button is owned here, before target/bubble handlers can compete with it. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('#gaFiltersOpen')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer();
      return;
    }

    if (target.closest('[data-ga-filters-close]') || target.id === 'gaFiltersBackdrop') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var els = getElements();
    if (!els.drawer || els.drawer.hidden) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeDrawer();
  }, true);

  /* Block the obsolete Alpine/legacy drawer event without touching the current drawer. */
  window.addEventListener('toggle-filters', function (event) {
    event.stopImmediatePropagation();
  }, true);

  function stabilise(root) {
    prepare();
    prioritiseVisibleProductImages(root || document);
  }

  function startObserver() {
    var target = document.querySelector('main') || document.body;
    if (!target || observer) return;

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) prioritiseVisibleProductImages(node);
        });
      });
      prepare();
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      stabilise(document);
      startObserver();
    }, { once: true });
  } else {
    stabilise(document);
    startObserver();
  }

  window.addEventListener('load', function () { stabilise(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (event) {
    stabilise(event.target || document);
  });
})();
